import { FC } from 'react'
import FilialModal from '@modals/FilialModal'
import ModalOnRoute from '@templates/ModalOnRoute'

const FilialModalOnRoute: FC = () => {
  return <ModalOnRoute Component={FilialModal} withoutCloseOnOutsideClick />
}

export default FilialModalOnRoute
